import React, { PureComponent } from 'react';
import { Col, Row } from 'react-bootstrap';

class DocumentosRelacionadoImpuestosSummaryItem extends PureComponent {
  render() {
    const { data } = this.props;

    return (
      <Row className="pt-3">
        <Col>
          Base: {data.BaseDR}
          <br />
          Impuesto: {data.ImpuestoDR}
          <br />
          Tipo Factor: {data.TipoFactorDR}
          <br />
          Tasa o Cuota: {data.TasaOCuotaDR}
          <br />
          Importe: {data.ImporteDR}
        </Col>
      </Row>
    );
  }
}

class DocumentosRelacionadoSummaryItem extends PureComponent {
  renderItem(item) {
    return (
      <DocumentosRelacionadoImpuestosSummaryItem
        key={item.id}
        data={item}
      />
    );
  }

  render() {
    const { data } = this.props;

    const { ImpuestosDR = {} } = data;
    const { TrasladosDR = {}, RetencionesDR = {} } = ImpuestosDR;
    const { TrasladoDR = [] } = TrasladosDR;
    const { RetencionDR = [] } = RetencionesDR;

    return (
      <>
        <div className="pb-3">
          <strong className="text-upper text-muted">Comprobantes</strong>
        </div>
        <div className="pb-1">
          <strong>{data.IdDocumento}</strong>
        </div>

        <Row>
          <Col>
            Serie: {data.Serie}
            <br />
            Folio: {data.Folio}
            <br />
            Moneda: {data.MonedaDR}
            <br />
            Método de pago: {data.MetodoDePagoDR}
          </Col>
          <Col>
            No. de parcialidad: {data.NumParcialidad}
            <br />
            Saldo anterior: {data.ImpSaldoAnt}
            <br />
            Importe pagado: {data.ImpPagado}
            <br />
            Saldo insoluto: {data.ImpSaldoInsoluto}
          </Col>
        </Row>

        {TrasladoDR.length > 0 && (
          <div className="py-3">
            <div className="pb-2">
              <strong className="text-upper text-muted">Traslados</strong>
            </div>

            {TrasladoDR.map(this.renderItem)}
          </div>
        )}

        {RetencionDR.length > 0 && (
          <div className="py-3">
            <div className="pb-2">
              <strong className="text-upper text-muted">Retenciones</strong>
            </div>

            {RetencionDR.map(this.renderItem)}
          </div>
        )}
      </>
    );
  }
}

class DocumentosRelacionadosSummary extends PureComponent {
  renderItem(item) {
    return (
      <DocumentosRelacionadoSummaryItem
        key={item.IdDocumento}
        data={item}
      />
    );
  }

  render() {
    const { data = [] } = this.props;

    return <div className="py-3">{data.map(this.renderItem)}</div>;
  }
}

export default DocumentosRelacionadosSummary;
